import TextMsg from './text-msg'
import LinkMsg from './link-msg'
import BtnMsg from './btn'
import MarkdownWidget from './markdown'
import ImageMsg from './image-msg'
import Waiting from './waiting'
import ImageWithTextMsg from './image-with-text'

const widgetMap = {
  btn: BtnMsg,
  text: TextMsg,
  link: LinkMsg,
  markdown: MarkdownWidget,
  image: ImageMsg,
  waiting: Waiting,
  image_with_text: ImageWithTextMsg
}

export default widgetMap
